import { SortingState } from '@tanstack/react-table';
import { ExpectedQueryData } from 'components/table/hooks/useServerFilteredTable';
import { getPaginationParams } from 'components/table/utils/pagination';
import { getSortParam } from 'components/table/utils/sorting';
import {
  GetCustomDataFieldsResponse,
  CustomDataField,
} from 'models/CustomDataField';
import API from 'services/API';

type QueryReturnType = ExpectedQueryData<CustomDataField>;

export const CUSTOM_DATA_FIELDS_BASE_QUERY_KEY = 'custom-data-fields';

export const CUSTOM_DATA_FIELDS_SORTING = {
  name: 'SORT_BY_NAME',
  type: 'SORT_BY_TYPE',
  variable: 'SORT_BY_VARIABLE',
};

export const customDataFieldsQuery = ({
  sorting,
  agencyUid,
  pageIndex,
  pageSize,
}: {
  sorting: SortingState;
  pageIndex: number;
  pageSize: number;
  agencyUid: string;
}) => ({
  queryKey: [
    CUSTOM_DATA_FIELDS_BASE_QUERY_KEY,
    'list',
    agencyUid,
    { pageIndex, sorting },
  ],
  queryFn: async (): Promise<QueryReturnType> => {
    const sort = getSortParam(sorting, CUSTOM_DATA_FIELDS_SORTING);

    const response = await API.get<GetCustomDataFieldsResponse>(
      '/api/v3.2/custom-data-fields',
      {
        params: {
          ...getPaginationParams({ pageIndex, pageSize }),
          ...(sort ? { sort: sort.sort, sortDirection: sort.direction } : {}),
          agencyUid,
          usage: 'CUSTOM_VARIABLES',
        },
      },
    );

    const { customDataFields, _metadata } = response.data;

    return {
      data: customDataFields,
      _metadata,
    };
  },
  enabled: true,
});
